import { Cookies } from 'react-cookie';
const AKAMAI_COOKIE = 'x-coxauto-aka-data';
export default function getAkamaiCookie() {
  const cookies = new Cookies();
  return cookies.get(AKAMAI_COOKIE);
}